/* eslint-disable no-console */
import {SORT} from '../incase-domain/common/sort.enum';
import {IPaginatedResult, IPaginatedSearch} from '../incase-domain/search';
import {User, UserConfig, UserCreateDTO, UserCredentials, UserWithConnection} from '../incase-domain/user';
import {UserFilterOptions} from '../incase-domain/userFilterOptions';
import {httpGet, httpPost} from './http.service';

export const login = (
    credentials: UserCredentials
): Promise<{
    user?: User;
    errors?: Record<string, string[]>;
}> => {
    return httpPost(`admin/auth/login`, credentials)
        .then((response) => {
            // ovo treba fixat
            return {user: response.data};
        })
        .catch((err) => {
            const {
                response: {data},
            } = err;

            return {errors: data};
        });
};

export const register = (
    user: UserCreateDTO,
    userConfig: UserConfig
): Promise<{
    success: boolean;
    errors?: Record<string, string[]>;
}> => {
    return httpPost(`admin/auth/register`, {user, userConfig})
        .then(() => ({success: true}))
        .catch((err) => {
            const res = {success: false};
            const {
                response: {data, status},
            } = err;

            if (status < 500) return {...res, errors: data};
            return res;
        });
};

export const fetchLoggedInUser = (): Promise<User | void> => {
    return httpGet(`admin/auth/current`).catch((error) => {
        console.log(error);
    });
};

export const fetchUserPage = (
    page: number,
    pageSize: number,
    filterQuery: UserFilterOptions,
    searchTerm?: string,
    sortBy?: Record<string, SORT>
): Promise<IPaginatedResult<User>> => {
    return httpPost(`admin/auth/users`, {page, pageSize, filterQuery, searchTerm, sortBy});
};

export const fetchUser = (id: string): Promise<User> => {
    return httpGet(`admin/auth/users/${id}`);
};

export const archiveUsers = (userIds: string[]): Promise<{success: boolean}> => {
    return httpPost('admin/auth/archive', {userIds})
        .then(() => ({success: true}))
        .catch((error) => {
            console.log(error);
            return {success: false};
        });
};

export const restoreUsers = (userIds: string[]): Promise<{success: boolean}> => {
    return httpPost('admin/auth/restore', {userIds})
        .then(() => ({success: true}))
        .catch((error) => {
            console.log(error);
            return {success: false};
        });
};

export const changeUserPassword = (
    userId: string,
    password: string,
    repeatPassword: string
): Promise<{success: boolean; errors?: Record<string, string[]>}> => {
    return httpPost(`admin/auth/changePassword`, {userId, password, repeatPassword})
        .then(() => ({success: true}))
        .catch((err) => {
            const res = {success: false};
            const {
                response: {data, status},
            } = err;

            if (status < 500) return {...res, errors: data};
            return res;
        });
};

export const forgotPassword = (email: string): Promise<{success: boolean; errors?: Record<string, string[]>}> => {
    return httpPost(`admin/auth/forgot`, {email})
        .then(() => ({success: true}))
        .catch((err) => {
            const res = {success: false};
            const {
                response: {data, status},
            } = err;

            if (status < 500) return {...res, errors: data};
            return res;
        });
};

export const resetPassword = (
    password: string,
    repeatPassword: string,
    code: string
): Promise<{success: boolean; errors?: Record<string, string[]>}> => {
    return httpPost(`admin/auth/reset`, {password, repeatPassword, code})
        .then(() => ({success: true}))
        .catch((err) => {
            const res = {success: false};
            const {
                response: {data, status},
            } = err;

            if (status < 500) return {...res, errors: data};
            return res;
        });
};

export const updateUser = (
    user: User,
    userConfig: UserConfig
): Promise<{success: true; user: User} | {success: false; errors?: Record<string, string[]>}> => {
    return httpPost<User>(`admin/auth/update`, {user, userConfig}, {})
        .then((data): {success: true; user: User} | {success: false} => {
            return {success: true, user: data};
        })
        .catch((err): {success: false; errors?: Record<string, string[]>} => {
            console.log(err);
            const {
                response: {data, status},
            } = err;

            if (status < 500) return {success: false, errors: data};
            return {success: false};
        });
};

export const fetchUsersForConnection = (paginatedSearch: IPaginatedSearch): Promise<IPaginatedResult<UserWithConnection> | void> => {
    const {pageNumber, pageSize, searchString} = paginatedSearch;
    return httpPost(`admin/auth/users/connection/${pageNumber}/${pageSize}`, {
        searchObj: {
            searchString,
            pageNumber,
            pageSize: 12,
        },
    }).catch((error) => {
        console.log(error);
    });
};

export const fetchDefaultUserConfigValues = (): Promise<UserConfig> => {
    return httpGet(`admin/auth/users/getDefaultUserConfigValues`);
};

export const logout = (): Promise<boolean> => {
    return httpPost(`admin/auth/logout`, {});
};

export const logoutFromAllUserSessions = (): Promise<boolean> => {
    return httpPost(`admin/auth/logout_sessions`);
};

export const importUsers = (usersCSV: File): Promise<number> => {
    const formData = new FormData();
    formData.append('file', usersCSV);

    return httpPost(`admin/auth/importUsers`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const searchUsers = (users: string[]): Promise<User[] | null> => {
    return httpPost('admin/auth/searchUsers', {userEmails: users});
};
